import KanBoIcon from 'components/KanBoIcon'
import { ListItem } from 'components/List'
import useGetData from 'hooks/useGetData'
import React, { useMemo } from 'react'
import { FormattedMessage } from 'components/Intl'
import { AllowedDocumentTemplateType } from './types'
import Document from 'components/Document'

const DocumentTemplateItem: React.FC<{
  type: AllowedDocumentTemplateType;
  documentTemplateSourceId: number;
  identifier: string;
  name: string;
  onRemove: () => void;
}> = ({
  type,
  documentTemplateSourceId,
  identifier,
  name,
  onRemove,
}) => {
  const documentTemplateItemsArgs = useMemo(() => {
    if (documentTemplateSourceId && identifier) {
      return {
        templateSourceId: documentTemplateSourceId,
        templateIdentifiers: [identifier],
      }
    }

    return null
  }, [documentTemplateSourceId, identifier])
  const {
    data: DocumentTemplateItems,
  }: {
    data: any;
  } = useGetData(documentTemplateItemsArgs ? 'DocumentTemplateItems' : undefined, documentTemplateItemsArgs)

  const DocumentTemplateItem = useMemo(() => {
    if (DocumentTemplateItems) {
      return DocumentTemplateItems[
        (() => {
          switch (type) {
            case 'source':
              return 'Sources'
            case 'folder':
              return 'Folders'
            case 'template':
              return 'Templates'
          }
        })()
      ][0]
    }

    return null
  }, [DocumentTemplateItems])

  const documentTemplateSourceArgs = useMemo(() => ({
    id: documentTemplateSourceId,
  }), [documentTemplateSourceId])
  const {
    data: DocumentTemplateSource,
  }: {
    data: any;
  } = useGetData(!identifier ? 'DocumentTemplateSourceDetailed' : undefined, documentTemplateSourceArgs)

  switch (type) {
    case 'source':
      return (
        <ListItem
          borderedIcon
          icon={
            <KanBoIcon
              fixedWidth
              name='kanbo-16-document-template-source'
            />
          }
          subtitle={DocumentTemplateSource?.Url}
          menu={[{
            icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
            title: <FormattedMessage id='REMOVE' />,
            onClick: onRemove,
          }]}
        >
          {name}
        </ListItem>
      )
    case 'folder':
      return (
        <Document
          objectType={1}
          listItem
          name={name}
          subtitle={DocumentTemplateItem?.Url}
          menu={[{
            icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
            title: <FormattedMessage id='REMOVE' />,
            onClick: onRemove,
          }]}
        />
      )
    case 'template':
      return (
        <Document
          listItem
          name={name}
          subtitle={DocumentTemplateItem?.Url}
          menu={[{
            icon: <KanBoIcon fixedWidth name='kanbo-16-remove' />,
            title: <FormattedMessage id='REMOVE' />,
            onClick: onRemove,
          }]}
        />
      )
  }
}

export default DocumentTemplateItem
